export default __webpack_public_path__ + "static/media/home-slider-3-comp.4a33be94.png";